
import React from "react";
import styles from "../assets/style.module.css";
import { IProfileWebsite } from "../../../../services";

export interface MerchProps {
    website: IProfileWebsite;
}

function Merch(props: MerchProps) {

    const MERCH = [
        { id: 1, name: "Home Jersey 2025/26", price: 89.99, img: "https://images.unsplash.com/photo-1620794108219-aedbde4e6fb0?w=400&q=80", badge: "New" },
        { id: 2, name: "Training Kit Set", price: 64.99, img: "https://images.unsplash.com/photo-1599481238640-4c1288750d7a?w=400&q=80", badge: null },
        { id: 3, name: "Signed Match Ball", price: 199.99, img: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400&q=80", badge: "Limited" },
        { id: 4, name: "MV10 Hoodie", price: 54.99, img: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=400&q=80", badge: null },
        { id: 5, name: "Away Jersey 2025/26", price: 89.99, img: "https://images.unsplash.com/photo-1571945192063-40f7fd5f7a49?w=400&q=80", badge: null },
        { id: 6, name: "MV10 Cap Collection", price: 29.99, img: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=400&q=80", badge: "Hot" },
    ];

    const addToCart = (item: any) => {
        
    };

    return (<div className={styles["section"]}>
        <div className={styles["sec-line"]} />
        <h1 className={styles["sec-title"]}><em>Official</em> Store</h1>
        <p className={styles["sec-sub"]}>Authentic Marco Vidal merchandise — shipped worldwide</p>
        <div className={styles["merch-grid"]}>
            {MERCH.map((item) => (
                <div key={item.id} className={styles["merch-card"]}>
                    <img className={styles["merch-img"]} src={item.img} alt={item.name} loading="lazy" />
                    <div className={styles["merch-body"]}>
                        {item.badge && <div className={styles["merch-badge"]}>{item.badge}</div>}
                        <div className={styles["merch-name"]}>{item.name}</div>
                        <div className={styles["merch-footer"]}>
                            <div className={styles["merch-price"]}>${item.price}</div>
                            <button className={styles["btn-add"]} onClick={() => addToCart(item)}>Add to Cart</button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>);

}

export default Merch;